import z from 'zod'

// このスキーマは env.ts（ランタイム）と vite.config.ts（ビルド時の設定漏れ検知）の両方から使う。
// v1 と異なり、監視系（Bugsnag/PostHog 等）はカットオーバー前に別途移植するため、
// ここでは v2 が実際に使う項目のみを定義する。
export const publicEnvSchema = z.object({
  VITE_API_HOST: z.string(),
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_SPA_APP_CLIENT_ID: z.string(),
  VITE_BUGSNAG_API_KEY: z.string().optional(),
  VITE_POSTHOG_API_KEY: z.string().optional(),
  VITE_POSTHOG_API_URL: z.string().optional(),
})
